const metaRenderer = (value, options, language) => {
  let result = value

  if(typeof value !== 'string'){
    if(value && value.length > 0){
      result = ''
      for (let index = 0; index < value.length; index++) {
        let id
        if(typeof value[index] === 'number'){
          id = value[index]
        } else {
          id = value[index].id
        }

        if(options && options.length > 0){
          for (let index1 = 0; index1 < options.length; index1++) {
            const element = options[index1];

            if(id === element.value){
              result+=`${element.label}${index < value.length-1 ? ', ' : ''}`
            }
          }
        }
        else if (value[index].nama && language){
          result+=`${value[index].nama[language.id]}${index < value.length-1 ? ', ' : ''}`
        }
        else {
          result+=`${id}${index < value.length-1 ? ', ' : ''}`
        }
      }
    } else {
      return '-'
    }
  }

  return result
}

export { metaRenderer }
